import { render, staticRenderFns } from "./BatchFieldsRemoved.vue?vue&type=template&id=221daa86&"
import script from "./BatchFieldsRemoved.vue?vue&type=script&lang=ts&"
export * from "./BatchFieldsRemoved.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports